import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader } from '..';
// import { ActionHeader } from '../index';
import en from '../../../../lang/en-us';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { OtpField, ResendOtp, useTimer } from '../../../../lib/OtpField';
import OtpSentTextWrapper from '../../../../lib/OtpSentTextWrapper';
import {
    verifyChangeEmailOTP as verifyOTP,
    updateEmail,
    sendPhoneOTP as sendOtp,
} from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { addDialCode, OTP_ACTIONS } from '../../../../utils/constants';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import { nextScreen } from '../ChangeMobile/flow';
import { RowInfoType } from './change-email-list';
import { SUCCESS } from './flow';
const { dashboard } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function ChangeEmailOtp(props: any) {
    const { enteredEmail, foliosToUpdate = [], emailRelationship } = props.location.state || {};

    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [loading, setLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        const { otp, reqId, otpRef } = props.location.state || {};
        if (!props.location.state || !foliosToUpdate.length) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const { pan = '', pekrn = '', mobile = '', email } = props;
            const goTo = nextScreen(props.match.path, 'email');
            const { action } = props.location.state;
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                email,
                mobile,
                pan,
                pekrn,
                action,
            };
            await props.verifyOTP(payload);
            if (goTo === SUCCESS) {
                const data = foliosToUpdate.map((ele: RowInfoType) => {
                    return {
                        amc: ele.amc,
                        folio: ele.id,
                        newEmail: enteredEmail,
                        emailRelationship,
                    };
                });
                let res = await props.updateEmail({
                    reqId,
                    mobile,
                    pan: props.pan,
                    pekrn: props.pekrn,
                    source: 'R',
                    data,
                });
                props.history.replace('change-email-success', {
                    data: foliosToUpdate,
                    email: enteredEmail,
                    ...(res || {}).body,
                });
                return;
            }
            props.history.replace(goTo, { foliosToUpdate });
            // props.history.replace(goTo, { ...(props?.location?.state || {}) });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const onResend = async () => {
        setShowModal(true);
        try {
            const { pan = '', pekrn = '' } = props;
            const { action } = props.location.state;
            let payload = { pan, pekrn, action };
            let res = await props.sendOtp(payload);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };
    // c
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.changeEmail.changeEmailHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        <OtpSentTextWrapper />
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    verifyOTP,
    updateEmail,
    sendOtp,
})(ChangeEmailOtp);
